import { message } from "~/components/ui";
import { useTranslation } from "react-i18next";

export const useOnClipboardCopy = () => {
  const { t } = useTranslation();

  const onCopyToClipboard = (_text: string, isSuccess: boolean) => {
    if (isSuccess) {
      message.info(t("common:copyToClipboardSuccess"));
    } else {
      message.error(t("common:copyToClipboardError"));
    }
  };

  return onCopyToClipboard;
};
